import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import config from "../../Config";
import SetupMenu from "./SetupMenu";
import WingsDropDown from "../Shared/WingsDropDown";
import SessionsDropDown from "../Shared/SessionsDropDown";

const ManageClassSyllabus = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [Wing_ID, setWing_ID] = useState("");
  const [SessionID, setSessionID] = useState(localStorage.getItem("DefaultSession"));
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    document.title = "Manage Class Syllabus";
  }, []);

  useEffect(() => {
    if (!Wing_ID || !SessionID) {
      setRows([]);
      setTotalRecords(0);
      return;
    }

    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "ClassSyllabus/GetClassSyllabusSummaryByWingSession",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        Wing_Id: Number(Wing_ID),
        SessionID: Number(SessionID)
      }
    })
      .then((res) => {
        if (res.data && res.data.status_code === 1) {
          const list = res.data.ListofRecords || [];
          setRows(list);
          setTotalRecords(list.length);
        } else {
          setRows([]);
          setTotalRecords(0);
          toast.error(res.data?.status_message || "Could not load class syllabus summary.");
        }
      })
      .catch(() => {
        setRows([]);
        setTotalRecords(0);
        toast.error("Could not load class syllabus summary.");
      })
      .finally(() => setLoading(false));
  }, [Wing_ID, SessionID, AccessKey, UserID, MemberType]);

  return (
    <>
      <ToastContainer />
      <SetupMenu />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><Link to="/Dashboard">Dashboard</Link></li>
                  <li className="breadcrumb-item"><Link to="/Setup/SetupDashboard">Setup</Link></li>
                  <li className="breadcrumb-item active" aria-current="page">Manage Class Syllabus</li>
                </ol>
              </nav>
              <div className="page-title">Manage Class Syllabus</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="card mb-2">
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Select Session:</label>
                    <select
                      className="form-select"
                      value={SessionID || "0"}
                      onChange={(e) => setSessionID(e.target.value)}
                    >
                      <option value="0">---All---</option>
                      <SessionsDropDown selectedSession={SessionID} />
                    </select>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Select Wing:</label>
                    <select
                      className="form-select"
                      value={Wing_ID || ""}
                      onChange={(e) => setWing_ID(e.target.value)}
                    >
                      <option value="">Please Select</option>
                      <WingsDropDown selectedWingId={Wing_ID} />
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="counting mt-4 text-end">
                    <span>{totalRecords} </span> Records Found!
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body table-wrap">
              <table className="table table-theme table-hover">
              <thead>
                <tr>
                  <th>Class ID</th>
                  <th>Class Code</th>
                  <th>Class Name</th>
                  <th>Wing</th>
                  <th>Session</th>
                  <th>Syllabus</th>
                  <th>Total Files</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="8" className="text-center">
                      <Spinner animation="border" role="status"></Spinner>
                    </td>
                  </tr>
                ) : rows.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No records found
                    </td>
                  </tr>
                ) : (
                  rows.map((item) => (
                    <tr key={item.Class_Id}>
                      <td>{item.Class_Id}</td>
                      <td>{item.Class_Code}</td>
                      <td>{item.Class_Name}</td>
                      <td>{item.Wing_Name}</td>
                      <td>{item.Session_Name}</td>
                      <td>{item.HasSyllabus ? "Exists" : "Missing"}</td>
                      <td>{item.SyllabusCount}</td>
                        <td className="text-center">
                          <Link
                            className="button button-primary button-sm"
                            to={`/Setup/ClassSyllabusFiles/${item.Class_Id}?className=${encodeURIComponent(
                              item.Class_Name || ""
                            )}`}
                          >
                            Manage Files
                          </Link>
                        </td>
                    </tr>
                  ))
                )}
              </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageClassSyllabus;
